import moment from 'moment'

export default {
  calculateAge: dateString => moment().diff(dateString, 'years'),
  getOrdinalDate: dateString => moment(dateString).format('Do MMM, YYYY'),
  formatDate: (dateString, format = 'DD MMM, YYYY') => moment(dateString).format(format),
  fromNow: (dateString) => moment(dateString).fromNow(),
  getTimeRange: (amount = 2, unit = 'hours') => { // for more info https://momentjs.com/docs/#/manipulating/subtract
    const to = new Date().toISOString()
    const from = moment().subtract(amount, unit).toDate().toISOString()
    return [from, to]
  },
  dateSubtract: (dateObj, amount, unit) => {
    return moment(dateObj).subtract(amount, unit).toDate()
  }
}
